module.exports = __webpack_public_path__ + "img/hc_pro_four_1.13b3602c.jpg";